const selectors = {
  itemImages: '.product-item__image-wrapper',
  collectionLinks: '.featured-collections .link-to-collection__featured-collection',
  buttonTabs: '.shopify-section--featured-collections .tabs-nav__item'
};

const buttonTabs = document.querySelectorAll(selectors.buttonTabs);
const linksToCollection = document.querySelectorAll(selectors.collectionLinks);

function setHeightToLinks() {
  linksToCollection.forEach(link => {
    const neighboringElement = link.parentNode.childNodes[1].querySelector(selectors.itemImages);

    if (neighboringElement) {
      const neighboringElementHeight = neighboringElement.clientHeight;
      link.style.height = `${neighboringElementHeight}px`;
    }
  });
}

if (linksToCollection && buttonTabs) {
  document.addEventListener('DOMContentLoaded', setHeightToLinks);
  window.addEventListener('resize', setHeightToLinks);
  buttonTabs.forEach(button => {
    button.addEventListener('click', () => {
      setTimeout(() => {
        setHeightToLinks();
      }, 1500);
    });
  });
}